import { defineComponent as nt, ref as T, computed as u, toRef as lt, onMounted as ot, watchEffect as it, onBeforeUnmount as at, onUpdated as st, watch as te, nextTick as Ie, h as z, cloneVNode as rt, withDirectives as ut, Transition as ct, vShow as dt, normalizeStyle as ft } from "vue";
import { calculateSize as Te, resolveSpeed as vt, clampValue as ne } from "./ghl-ui.es925.js";
import { provideCarouselContext as mt } from "./ghl-ui.es926.js";
import ht from "./ghl-ui.es927.js";
import gt from "./ghl-ui.es928.js";
import St, { isCarouselItem as pt } from "./ghl-ui.es257.js";
import xt from "./ghl-ui.es929.js";
import yt from "./ghl-ui.es854.js";
import { keep as Ve } from "./ghl-ui.es930.js";
import { getDisplayTotalView as wt, getRealIndex as he, getDisplayIndex as De, addDuplicateSlides as bt, getPrevIndex as Rt, getNextIndex as Ct } from "./ghl-ui.es931.js";
import zt from "./ghl-ui.es712.js";
import Me from "./ghl-ui.es855.js";
import { useThemeClass as Pt } from "./ghl-ui.es857.js";
import { flatten as It } from "./ghl-ui.es932.js";
import Ee from "./ghl-ui.es887.js";
import { resolveSlotWithProps as Ne } from "./ghl-ui.es860.js";
import { getPreciseEventTarget as Tt } from "./ghl-ui.es875.js";
import { isTouchEvent as Oe } from "./ghl-ui.es933.js";
import { on as W, off as U } from "./ghl-ui.es710.js";
import Vt from "./ghl-ui.es934.js";
const Dt = ["transitionDuration", "transitionTimingFunction"], Et = Object.assign(Object.assign({}, Me.props), {
  defaultIndex: {
    type: Number,
    default: 0
  },
  currentIndex: Number,
  showArrow: Boolean,
  dotType: {
    type: String,
    default: "dot"
  },
  dotPlacement: {
    type: String,
    default: "bottom"
  },
  slidesPerView: {
    type: [Number, String],
    default: 1
  },
  spaceBetween: {
    type: Number,
    default: 0
  },
  centeredSlides: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  autoplay: Boolean,
  interval: {
    type: Number,
    default: 5e3
  },
  loop: {
    type: Boolean,
    default: !0
  },
  effect: {
    type: String,
    default: "slide"
  },
  showDots: {
    type: Boolean,
    default: !0
  },
  trigger: {
    type: String,
    default: "click"
  },
  transitionStyle: {
    type: Object,
    default: () => ({
      transitionDuration: "300ms"
    })
  },
  transitionProps: Object,
  draggable: Boolean,
  prevSlideStyle: [Object, String],
  nextSlideStyle: [Object, String],
  touchable: {
    type: Boolean,
    default: !0
  },
  mousewheel: Boolean,
  keyboard: Boolean,
  "onUpdate:currentIndex": Function,
  onUpdateCurrentIndex: Function
});
let ge = !1;
const Zt = nt({
  name: "Carousel",
  props: Et,
  setup(l) {
    const {
      mergedClsPrefixRef: f,
      inlineThemeDisabled: P
    } = yt(l), $ = T(null), F = T(null), x = T([]), A = {
      value: []
    }, y = u(() => l.direction === "vertical"), R = u(() => y.value ? "height" : "width"), le = u(() => y.value ? "bottom" : "right"), c = u(() => l.effect === "slide"), d = u(
      // duplicate the copy operation in `slide` mode,
      // because only its DOM is sequence layout
      () => l.loop && l.slidesPerView === 1 && c.value
    ), V = u(() => l.effect === "custom"), D = u(() => !c.value || l.centeredSlides ? 1 : l.slidesPerView), B = u(() => V.value ? 1 : l.slidesPerView), v = u(() => D.value === "auto" || l.slidesPerView === "auto" && l.centeredSlides), m = T({
      width: 0,
      height: 0
    }), w = u(() => {
      const {
        value: e
      } = x;
      if (!e.length)
        return [];
      const {
        value: t
      } = v;
      if (t)
        return e.map((r) => Te(r));
      const {
        value: n
      } = B, {
        value: i
      } = m, {
        value: a
      } = R;
      let o = i[a];
      if (n !== "auto") {
        const {
          spaceBetween: r
        } = l, h = o - (n - 1) * r, ee = 1 / Math.max(1, n);
        o = h * ee;
      }
      const s = Object.assign(Object.assign({}, i), {
        [a]: o
      });
      return e.map(() => s);
    }), E = u(() => {
      const {
        value: e
      } = w;
      if (!e.length)
        return [];
      const {
        centeredSlides: t,
        spaceBetween: n
      } = l, {
        value: i
      } = R, {
        [i]: a
      } = m.value;
      let o = 0;
      return e.map(({
        [i]: s
      }) => {
        let r = o;
        return t && (r += (s - a) / 2), o += s + n, r;
      });
    }), Se = T(!1), oe = u(() => {
      const {
        transitionStyle: e
      } = l;
      return e ? Ve(e, Dt) : {};
    }), ie = u(() => V.value ? 0 : vt(oe.value.transitionDuration)), pe = u(() => {
      const {
        value: e
      } = x;
      if (!e.length)
        return [];
      const t = !(v.value || B.value === 1), n = (s) => {
        if (t) {
          const {
            value: r
          } = R;
          return {
            [r]: `${w.value[s][r]}px`
          };
        }
      };
      if (V.value)
        return e.map((s, r) => n(r));
      const {
        effect: i,
        spaceBetween: a
      } = l, {
        value: o
      } = le;
      return e.reduce((s, r, h) => {
        const ee = Object.assign(Object.assign({}, n(h)), {
          [`margin-${o}`]: `${a}px`
        });
        return s.push(ee), Se.value && (i === "fade" || i === "card") && Object.assign(ee, oe.value), s;
      }, []);
    }), g = u(() => {
      const {
        value: e
      } = D, {
        length: t
      } = x.value;
      if (e !== "auto")
        return Math.max(t - e, 0) + 1;
      {
        const {
          value: n
        } = w, {
          length: i
        } = n;
        if (!i)
          return t;
        const {
          value: a
        } = E, {
          value: o
        } = R, s = m.value[o];
        let r = n[n.length - 1][o], h = i;
        for (; h > 1 && r < s; )
          h--, r += a[h] - a[h - 1];
        return ne(h + 1, 1, i);
      }
    }), X = u(() => wt(g.value, d.value)), je = he(l.defaultIndex, d.value), ae = T(De(je, g.value, d.value)), b = zt(lt(l, "currentIndex"), ae), S = u(() => he(b.value, d.value));
    function k(e) {
      var t, n;
      e = ne(e, 0, g.value - 1);
      const i = De(e, g.value, d.value), {
        value: a
      } = b;
      i !== b.value && (ae.value = i, (t = l["onUpdate:currentIndex"]) === null || t === void 0 || t.call(l, i, a), (n = l.onUpdateCurrentIndex) === null || n === void 0 || n.call(l, i, a));
    }
    function Y(e = S.value) {
      return Rt(e, g.value, l.loop);
    }
    function q(e = S.value) {
      return Ct(e, g.value, l.loop);
    }
    function $e(e) {
      const t = N(e);
      return t !== null && Y() === t;
    }
    function Ae(e) {
      const t = N(e);
      return t !== null && q() === t;
    }
    function xe(e) {
      return S.value === N(e);
    }
    function Be(e) {
      return b.value === e;
    }
    function ye() {
      return Y() === null;
    }
    function we() {
      return q() === null;
    }
    function se(e) {
      const t = ne(he(e, d.value), 0, g.value);
      (e !== b.value || t !== S.value) && k(t);
    }
    function re() {
      const e = Y();
      e !== null && k(e);
    }
    function H() {
      const e = q();
      e !== null && k(e);
    }
    function ke() {
      (!p || !d.value) && re();
    }
    function _e() {
      (!p || !d.value) && H();
    }
    let p = !1, I = 0;
    const ue = T({});
    function K(e, t = 0) {
      ue.value = Object.assign({}, oe.value, {
        transform: y.value ? `translateY(${-e}px)` : `translateX(${-e}px)`,
        transitionDuration: `${t}ms`
      });
    }
    function _(e = 0) {
      c.value ? ce(S.value, e) : I !== 0 && (!p && e > 0 && (p = !0), K(I = 0, e));
    }
    function ce(e, t) {
      const n = be(e);
      n !== I && t > 0 && (p = !0), I = be(S.value), K(n, t);
    }
    function be(e) {
      let t;
      return e >= g.value - 1 ? t = Re() : t = E.value[e] || 0, t;
    }
    function Re() {
      if (D.value === "auto") {
        const {
          value: e
        } = R, {
          [e]: t
        } = m.value, {
          value: n
        } = E, i = n[n.length - 1];
        let a;
        if (i === void 0)
          a = t;
        else {
          const {
            value: o
          } = w;
          a = i + o[o.length - 1][e];
        }
        return a - t;
      } else {
        const {
          value: e
        } = E;
        return e[g.value - 1] || 0;
      }
    }
    const L = {
      currentIndexRef: b,
      to: se,
      prev: ke,
      next: _e,
      isVertical: () => y.value,
      isHorizontal: () => !y.value,
      isPrev: $e,
      isNext: Ae,
      isActive: xe,
      isPrevDisabled: ye,
      isNextDisabled: we,
      getSlideIndex: N,
      getSlideStyle: Ue,
      addSlide: Le,
      removeSlide: We,
      onCarouselItemClick: Fe
    };
    mt(L);
    function Le(e) {
      e && x.value.push(e);
    }
    function We(e) {
      if (!e)
        return;
      const t = N(e);
      t !== -1 && x.value.splice(t, 1);
    }
    function N(e) {
      return typeof e == "number" ? e : e ? x.value.indexOf(e) : -1;
    }
    function Ue(e) {
      const t = N(e);
      if (t !== -1) {
        const n = [pe.value[t]], i = L.isPrev(t), a = L.isNext(t);
        return i && n.push(l.prevSlideStyle || ""), a && n.push(l.nextSlideStyle || ""), ft(n);
      }
    }
    function Fe(e, t) {
      let n = !p && !Q && !me;
      l.effect === "card" && n && !xe(e) && (se(e), n = !1), n || (t.preventDefault(), t.stopPropagation());
    }
    let G = null;
    function J() {
      G && (clearInterval(G), G = null);
    }
    function O() {
      J(), !l.autoplay || X.value < 2 || (G = window.setInterval(H, l.interval));
    }
    let de = 0, fe = 0, C = 0, ve = 0, Q = !1, me = !1;
    function Ce(e) {
      var t;
      if (ge || !(!((t = F.value) === null || t === void 0) && t.contains(Tt(e))))
        return;
      ge = !0, Q = !0, me = !1, ve = Date.now(), J(), e.type !== "touchstart" && !e.target.isContentEditable && e.preventDefault();
      const n = Oe(e) ? e.touches[0] : e;
      y.value ? fe = n.clientY : de = n.clientX, l.touchable && (W("touchmove", document, Z), W("touchend", document, M), W("touchcancel", document, M)), l.draggable && (W("mousemove", document, Z), W("mouseup", document, M));
    }
    function Z(e) {
      const {
        value: t
      } = y, {
        value: n
      } = R, i = Oe(e) ? e.touches[0] : e, a = t ? i.clientY - fe : i.clientX - de, o = m.value[n];
      C = ne(a, -o, o), e.cancelable && e.preventDefault(), c.value && K(I - C, 0);
    }
    function M() {
      const {
        value: e
      } = S;
      let t = e;
      if (!p && C !== 0 && c.value) {
        const n = I - C, i = [...E.value.slice(0, g.value - 1), Re()];
        let a = null;
        for (let o = 0; o < i.length; o++) {
          const s = Math.abs(i[o] - n);
          if (a !== null && a < s)
            break;
          a = s, t = o;
        }
      }
      if (t === e) {
        const n = Date.now() - ve, {
          value: i
        } = R, a = m.value[i];
        C > a / 2 || C / n > 0.4 ? t = Y(e) : (C < -a / 2 || C / n < -0.4) && (t = q(e));
      }
      t !== null && t !== e ? (me = !0, k(t), Ie(() => {
        (!d.value || ae.value !== b.value) && _(ie.value);
      })) : _(ie.value), ze(), O();
    }
    function ze() {
      Q && (ge = !1), Q = !1, de = 0, fe = 0, C = 0, ve = 0, U("touchmove", document, Z), U("touchend", document, M), U("touchcancel", document, M), U("mousemove", document, Z), U("mouseup", document, M);
    }
    function Xe() {
      if (c.value && p) {
        const {
          value: e
        } = S;
        ce(e, 0);
      } else
        O();
      c.value && (ue.value.transitionDuration = "0ms"), p = !1;
    }
    function Ye(e) {
      if (e.preventDefault(), p)
        return;
      let {
        deltaX: t,
        deltaY: n
      } = e;
      e.shiftKey && !t && (t = n);
      const i = -1, a = 1, o = (t || n) > 0 ? a : i;
      let s = 0, r = 0;
      y.value ? r = o : s = o;
      const h = 10;
      (r * n >= h || s * t >= h) && (o === a && !we() ? H() : o === i && !ye() && re());
    }
    function qe() {
      m.value = Te($.value, !0), O();
    }
    function He() {
      var e, t;
      v.value && ((t = (e = w.effect).scheduler) === null || t === void 0 || t.call(e), w.effect.run());
    }
    function Ke() {
      l.autoplay && J();
    }
    function Ge() {
      l.autoplay && O();
    }
    ot(() => {
      it(O), requestAnimationFrame(() => Se.value = !0);
    }), at(() => {
      ze(), J();
    }), st(() => {
      const {
        value: e
      } = x, {
        value: t
      } = A, n = /* @__PURE__ */ new Map(), i = (o) => (
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        n.has(o) ? n.get(o) : -1
      );
      let a = !1;
      for (let o = 0; o < e.length; o++) {
        const s = t.findIndex((r) => r.el === e[o]);
        s !== o && (a = !0), n.set(e[o], s);
      }
      a && e.sort((o, s) => i(o) - i(s));
    }), te(S, (e, t) => {
      if (e !== t)
        if (O(), c.value) {
          if (d.value) {
            const {
              value: n
            } = g;
            X.value > 2 && e === n - 2 && t === 1 ? e = 0 : e === 1 && t === n - 2 && (e = n - 1);
          }
          ce(e, ie.value);
        } else
          _();
    }, {
      immediate: !0
    }), te([d, D], () => void Ie(() => {
      k(S.value);
    })), te(E, () => {
      c.value && _();
    }, {
      deep: !0
    }), te(c, (e) => {
      e ? _() : (p = !1, K(I = 0));
    });
    const Je = u(() => ({
      onTouchstartPassive: l.touchable ? Ce : void 0,
      onMousedown: l.draggable ? Ce : void 0,
      onWheel: l.mousewheel ? Ye : void 0
    })), Qe = u(() => Object.assign(Object.assign({}, Ve(L, ["to", "prev", "next", "isPrevDisabled", "isNextDisabled"])), {
      total: X.value,
      currentIndex: b.value
    })), Ze = u(() => ({
      total: X.value,
      currentIndex: b.value,
      to: L.to
    })), et = {
      getCurrentIndex: () => b.value,
      to: se,
      prev: re,
      next: H
    }, tt = Me("Carousel", "-carousel", xt, Vt, l, f), Pe = u(() => {
      const {
        common: {
          cubicBezierEaseInOut: e
        },
        self: {
          dotSize: t,
          dotColor: n,
          dotColorActive: i,
          dotColorFocus: a,
          dotLineWidth: o,
          dotLineWidthActive: s,
          arrowColor: r
        }
      } = tt.value;
      return {
        "--n-bezier": e,
        "--n-dot-color": n,
        "--n-dot-color-focus": a,
        "--n-dot-color-active": i,
        "--n-dot-size": t,
        "--n-dot-line-width": o,
        "--n-dot-line-width-active": s,
        "--n-arrow-color": r
      };
    }), j = P ? Pt("carousel", void 0, Pe, l) : void 0;
    return Object.assign(Object.assign({
      mergedClsPrefix: f,
      selfElRef: $,
      slidesElRef: F,
      slideVNodes: A,
      duplicatedable: d,
      userWantsControl: V,
      autoSlideSize: v,
      realIndex: S,
      slideStyles: pe,
      translateStyle: ue,
      slidesControlListeners: Je,
      handleTransitionEnd: Xe,
      handleResize: qe,
      handleSlideResize: He,
      handleMouseenter: Ke,
      handleMouseleave: Ge,
      isActive: Be,
      arrowSlotProps: Qe,
      dotSlotProps: Ze
    }, et), {
      cssVars: P ? void 0 : Pe,
      themeClass: j == null ? void 0 : j.themeClass,
      onRender: j == null ? void 0 : j.onRender
    });
  },
  render() {
    var l;
    const {
      mergedClsPrefix: f,
      showArrow: P,
      userWantsControl: $,
      slideStyles: F,
      dotType: x,
      dotPlacement: A,
      slidesControlListeners: y,
      transitionProps: R = {},
      arrowSlotProps: le,
      dotSlotProps: c,
      $slots: {
        default: d,
        dots: V,
        arrow: D
      }
    } = this, B = d && It(d()) || [];
    let v = Nt(B);
    return v.length || (v = B.map((m) => z(St, null, {
      default: () => rt(m)
    }))), this.duplicatedable && (v = bt(v)), this.slideVNodes.value = v, this.autoSlideSize && (v = v.map((m) => z(Ee, {
      onResize: this.handleSlideResize
    }, {
      default: () => m
    }))), (l = this.onRender) === null || l === void 0 || l.call(this), z("div", Object.assign({
      ref: "selfElRef",
      class: [this.themeClass, `${f}-carousel`, this.direction === "vertical" && `${f}-carousel--vertical`, this.showArrow && `${f}-carousel--show-arrow`, `${f}-carousel--${A}`, `${f}-carousel--${this.direction}`, `${f}-carousel--${this.effect}`, $ && `${f}-carousel--usercontrol`],
      style: this.cssVars
    }, y, {
      onMouseenter: this.handleMouseenter,
      onMouseleave: this.handleMouseleave
    }), z(Ee, {
      onResize: this.handleResize
    }, {
      default: () => z("div", {
        ref: "slidesElRef",
        class: `${f}-carousel__slides`,
        role: "listbox",
        style: this.translateStyle,
        onTransitionend: this.handleTransitionEnd
      }, $ ? v.map((m, w) => z("div", {
        style: F[w],
        key: w
      }, ut(z(ct, Object.assign({}, R), {
        default: () => m
      }), [[dt, this.isActive(w)]]))) : v)
    }), this.showDots && c.total > 1 && Ne(V, c, () => [z(ht, {
      key: x + A,
      total: c.total,
      currentIndex: c.currentIndex,
      dotType: x,
      trigger: this.trigger,
      keyboard: this.keyboard
    })]), P && Ne(D, le, () => [z(gt, null)]));
  }
});
function Nt(l) {
  return l.reduce((f, P) => (pt(P) && f.push(P), f), []);
}
export {
  Et as carouselProps,
  Zt as default
};
